import { NavLink, useLocation } from "react-router-dom";
import { Building2, Calendar, FileText, Image, Inbox, LayoutDashboard, LogOut, Megaphone, Quote, Settings, Users } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useAdminAuth } from "@/hooks/useAdminAuth";

const navItems = [
  { title: "Dashboard", url: "/admin", icon: LayoutDashboard, end: true },
  { title: "Submissions", url: "/admin/submissions", icon: Inbox, end: false },
  { title: "Pages", url: "/admin/pages", icon: FileText, end: false },
  { title: "Announcements", url: "/admin/announcements", icon: Megaphone, end: false },
  { title: "Events", url: "/admin/events", icon: Calendar, end: false },
  { title: "Properties", url: "/admin/properties", icon: Building2, end: false },
  { title: "Team", url: "/admin/team", icon: Users, end: false },
  { title: "Testimonials", url: "/admin/testimonials", icon: Quote, end: false },
  { title: "Media", url: "/admin/media", icon: Image, end: false },
  { title: "Settings", url: "/admin/settings", icon: Settings, end: false },
];

const AdminSidebar = () => {
  const { pathname } = useLocation();
  const { signOut, user } = useAdminAuth();

  const isActive = (url: string, end: boolean) =>
    end ? pathname === url : pathname === url || pathname.startsWith(url + "/");

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <div className="px-3 py-4">
          <p className="font-headline text-lg leading-tight text-sidebar-foreground">
            Hadassah Homes
          </p>
          <p className="mt-0.5 text-[11px] uppercase tracking-[0.18em] text-sidebar-foreground/60">
            Admin
          </p>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Manage</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild isActive={isActive(item.url, item.end)}>
                    <NavLink to={item.url} end={item.end} className="flex items-center gap-2">
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <div className="space-y-2 px-3 pb-3">
          {user?.email ? (
            <p className="truncate text-[11px] text-sidebar-foreground/60" title={user.email}>
              {user.email}
            </p>
          ) : null}
          <button
            onClick={() => signOut()}
            className="flex w-full items-center gap-2 px-2 py-2 text-sm text-sidebar-foreground/80 transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
          >
            <LogOut className="h-4 w-4" />
            <span>Sign out</span>
          </button>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
};

export default AdminSidebar;
